import { AxiosError } from "axios";
import {
  Button,
  Menu,
  Spinner,
  Select,
  Box,
  Form,
  FormField,
  TextInput,
  Layer,
  SelectMultiple,
} from "grommet";
import { DataTable } from "grommet/components/DataTable";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useErrorHandler } from "../../../common/context/ErrorStore";
import RightSidebar from "../../../common/right-sidebar/RightSidebar";
import { PermissionTableColumns } from "../Permissions/components/PermissionTableColumns";
import permissionsService from "../Permissions/permissions.service";
import { PermissionType } from "../Permissions/types/PermissionType";
import { RoleTableColumns } from "../Roles/components/RoleTableColumns";
import rolesService from "../Roles/roles.service";
import { RoleType } from "../Roles/types/RoleType";
import { UserTableColumns } from "./components/UserTableColumns";
import { PermissionTableStateType } from "./types/PermissionTableStateType";
import { RoleTableStateType } from "./types/RoleTableStateType";
import { UserType } from "./types/UserType";
import "./Users.css";
import usersService from "./users.service";
import UsersService from "./users.service";
import ConfirmationDialog from "../../../common/confirmation-dialog/ConfirmationDialog";
import useLongPress from "../../../common/util/LongPress";
import { RightSidebarStateType } from "../../../common/right-sidebar/types/RightSidebarStateType";
import { OrganizationType } from "./types/OrganizationType";
import StandardColors from "../../../../../../util/StandardColors";
import { observer } from "mobx-react";
import { useStore } from "../../../../../../Hooks/useStore";
import { reaction, toJS } from "mobx";
import { Mixpanel } from "../../../../../../util/Helper";
import CommonSearchInput from "../../../common/SearchInput/CommonSearchInput";
import CommonButton from "../../../common/Button/CommonButton";
import { UserFromFileType } from "./types/UserFromFileType";
import createuserService from "./CreateUser/createuser.service";
import { setUser } from "@sentry/react";
import closeAddUserSidebar from "../../../../../../assets/close_small.svg";
import excelFileAddUser from "../../../../../../assets/Microsoft excel.svg";
import userActionDropdown from "../../../../../../assets/arrow_drop_down (1).svg";
import DisableRightSidebar from "../../../common/right-sidebar/DisableRightSidebar";
import searchIcon from "../../../../../../assets/iconamoon_search-light.svg";
import EditProfileUsers from "../../../common/right-sidebar/EditProfileUsers";
import NoDataFound from "../../../../../../assets/urban-no-data-found-3 1.png";
import Pagination from "../../../common/Pagination/Pagination";

const Users = observer(() => {
  const { rootStore } = useStore();
  const [users, setUsers] = useState([] as UserType[]);
  const [originalUsersList, setOriginalUsersList] = useState([] as UserType[]);
  // const [newUser, setNewUser] = useState({ ...initialFlightData,msn: '', tailNumber: '' });

  const [searchString, setSearchString] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedOrgId, setSelectedOrgId] = useState<string | null>(null);

  const [itemsPerPage] = useState(10);
  const [fileError, setFileError] = useState("");

  const [selectedUsers, setSelectedUsers] = useState<(string | number)[]>([]);

  const [selectionActivated, setSelectionActivated] = useState(false);

  const [organizations, setOrganizations] = useState<OrganizationType[]>([]);
  const [organizationId, setOrganizationId] = useState("");
  const [
    showRightSidebarPermissionSelection,
    setShowRightSidebarPermissionSelection,
  ] = useState(false);

  const [showRightSidebarRoleSelection, setShowRightSidebarRoleSelection] =
    useState(false);

  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [dropdownOpen2, setDropdownOpen2] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');


  const handleButtonClick = () => {
    setDropdownOpen1(!dropdownOpen1);
  };
  const handleButtonClick2 = () => {
    setDropdownOpen2(!dropdownOpen2)
  }



  const [permissionTableState, setPermissionTableState] =
    useState<PermissionTableStateType>({} as PermissionTableStateType);

  const [roleTableState, setRoleTableState] = useState<RoleTableStateType>(
    {} as RoleTableStateType
  );

  const [showDisableConfirmation, setShowDisableConfirmation] = useState(false);

  const [rightSidebarState, setRightSidebarState] = useState(
    {} as RightSidebarStateType<(string | number)[]>
  );

  const organizationList = async () => {
    let organizations = await usersService.listOrganizations();
    rootStore.adminStore.handleUserOrganization(organizations);
  };
  useEffect(() => {
    organizationList();
  }, []);

  // alert(JSON.stringify(organizationList))

  const [searchText, setSearchText] = useState("");


  // Filter the organizations based on search text
  console.log("dsfgdgddd", rootStore.adminStore.getCreateFlightOrgList);
  const filteredOptions = rootStore.adminStore.getCreateFlightOrgList.filter((org) =>
    org.name.toLowerCase().includes(searchText.toLowerCase())
  );

  // alert(JSON.stringify(filteredOptions))

  const navigate = useNavigate();

  // configure long press on table row
  const defaultOptions = {
    shouldPreventDefault: true,
    delay: 500,
  };

  // const longPressEvent = useLongPress(
  //   () => {
  //     rootStore.adminStore.handleUserSelectedActivation(true);
  //   },
  //   () => {},
  //   defaultOptions
  // );

  const assignPermissionsToUser = (permissions: (string | number)[]) => {
    usersService
      .assignPermissionsToUsers(
        rootStore.adminStore.getSelectedusers as string[],
        permissions as string[]
      )
      .then(() => {
        rootStore.notificationToastStore.showNotification(
          "Permission assigned successfully.",
          false,
          3000
        );
        rootStore.adminStore.handleUserRightSidebar(false);
      })
      .catch((error) => {
        if (error instanceof AxiosError) {
          if (error.response) {
            if (error.response.status == 400) {
              // the user version is older
              rootStore.errorHandlingStore.displayError(
                "The user version is not compatible, please select different User!"
              );
            } else {
              rootStore.errorHandlingStore.displayError(error.message);
            }
          } else {
            rootStore.errorHandlingStore.displayError(error.message);
          }
        } else {
          rootStore.errorHandlingStore.displayError(
            "Error occured while assigning permissions to the users."
          );
        }
      });
  };
  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };
  const revokePermissionsFromUser = (permissions: (string | number)[]) => {
    usersService
      .revokePermissionsFromUser(
        rootStore.adminStore.getSelectedusers[0] as string,
        permissions as string[]
      )
      .then(() => {
        rootStore.notificationToastStore.showNotification(
          "Permission revoked successfully.",
          false,
          3000
        );

        rootStore.adminStore.handleUserRightSidebar(false);
      })
      .catch((error) => {
        if (error instanceof AxiosError) {
          if (error.response) {
            if (error.response.status == 400) {
              // the user version is older
              rootStore.errorHandlingStore.displayError(
                "The user version is not compatible, please select different User!"
              );
            } else {
              rootStore.errorHandlingStore.displayError(error.message);
            }
          } else {
            rootStore.errorHandlingStore.displayError(error.message);
          }
        } else {
          rootStore.errorHandlingStore.displayError(
            "Error occured while assigning permissions to the users."
          );
        }
      });
  };

  const assignRolesToUser = (roles: (string | number)[]) => {
    usersService
      .assignRolesToUsers(
        rootStore.adminStore.getSelectedusers as string[],
        roles as string[]
      )
      .then((res) => {
        rootStore.notificationToastStore.showNotification(
          "Roles assigned successfully.",
          false,
          3000
        );
        rootStore.adminStore.handleUserRightSidebarRoleSelection(false);
      })
      .catch((error) => {
        if (error instanceof AxiosError) {
          if (error.response) {
            if (error.response.status == 400) {
              // the user version is older
              rootStore.errorHandlingStore.displayError(
                "The user version is not compatible, please select different User!"
              );
            } else {
              rootStore.errorHandlingStore.displayError(error.message);
            }
          } else {
            rootStore.errorHandlingStore.displayError(error.message);
          }
        } else {
          rootStore.errorHandlingStore.displayError(
            "Error occured while assigning roles to the users."
          );
        }
      });
  };

  const [userOrgId, setUserOrgId] = useState(rootStore.adminStore.getUserOrgId);

  const handleChange = (e: any) => {
    setUserOrgId(e.target.value);
    rootStore.adminStore.handleUserOrgId(e.target.value);
  };

  const revokeRolesFromUser = (roles: (string | number)[]) => {
    usersService
      .revokeRolesFromUser(
        rootStore.adminStore.getSelectedusers[0] as string,
        roles as string[]
      )
      .then((res) => {
        rootStore.notificationToastStore.showNotification(
          "Roles revoked successfully.",
          false,
          3000
        );
        rootStore.adminStore.handleUserRightSidebarRoleSelection(false);
      })
      .catch((error) => {
        if (error instanceof AxiosError) {
          if (error.response) {
            if (error.response.status == 400) {
              // the user version is older
              // rootStore.errorHandlingStore.displayError(
              //   "The user version is not compatible, please select different User!"
              rootStore.notificationToastStore.showNotification(
                "The user version is not compatible, please select different User!",
                true,
                3000
              );
              // );
            } else {
              rootStore.notificationToastStore.showNotification(
                error.message,
                true,
                3000
              );
            }
          } else {
            rootStore.notificationToastStore.showNotification(
              error.message,
              true,
              3000
            );
          }
        } else {
          rootStore.notificationToastStore.showNotification(
            "Error occured while assigning roles to the users.",
            true,
            3000
          );
          // rootStore.errorHandlingStore.displayError("Error occured while assigning roles to the users.");
          // rootStore.errorHandlingStore.displayError("Error occured while assigning roles to the users.");
        }
      });
  };

  const assignPermission = useCallback(async () => {
    rootStore.rightSidebarStore.setSelectedItems([]);

    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
      const userinformation = JSON.parse(uInfos);
      Mixpanel.track("web_user_assign_permission_click", {
        name: userinformation.username,
      });
    }
    // Get list of permissions
    // Prepare columns
    // display selection sidebar
    try {
      const permissions: PermissionType[] =
        await permissionsService.listAllPermissions();

      const columns = PermissionTableColumns;
      rootStore.adminStore.handleUserPermissionTableState({
        data: permissions,
        columns: columns,
      });
      rootStore.adminStore.handleUserRightSidebarState({
        title: "Select Permissions to Assign",
        description:
          "Please select all the permission you want to assign to the selected users.",
        onSubmit: assignPermissionsToUser,
        submitButtonTitle: "Assign Permissions",
        tableTitle: "Permissions",
      });
      rootStore.adminStore.handleUserRightSidebar(true);
      rootStore.adminStore.setUsersActionMenu();
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response) {
          if (error.response.status == 400) {
            rootStore.notificationToastStore.showNotification(
              "The user version is not compatible, please select different User!",
              true,
              3000
            );
            // the user version is older
          } else {
            rootStore.notificationToastStore.showNotification(
              error.message,
              true,
              3000
            );
          }
        } else {
          rootStore.notificationToastStore.showNotification(
            error.message,
            true,
            3000
          );
        }
      } else {
        // rootStore.errorHandlingStore.displayError("unable to get permission, please reload the page!");
        rootStore.notificationToastStore.showNotification(
          "unable to get permission, please reload the page!",
          true,
          3000
        );
      }
    }
  }, [assignPermissionsToUser]);

  const revokePermissions = useCallback(async () => {
    rootStore.rightSidebarStore.setSelectedItems([]);
    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
      const userinformation = JSON.parse(uInfos);
      Mixpanel.track("web_user_revoke_permission_click", {
        name: userinformation.username,
      });
    }
    // Get list of permissions
    // Prepare columns
    // display selection sidebar
    try {
      const permissions: PermissionType[] =
        await usersService.getUserPermissions(
          rootStore.adminStore.getSelectedusers[0] as string
        );

      const columns = PermissionTableColumns;
      rootStore.adminStore.handleUserPermissionTableState({
        data: permissions,
        columns: columns,
      });
      rootStore.adminStore.handleUserRightSidebarState({
        title: "Select Permissions to Revoke",
        description:
          "Please select all the permission you want to revoke to the selected users.",
        onSubmit: revokePermissionsFromUser,
        submitButtonTitle: "Revoke",
        tableTitle: "Permissions",
      });
      rootStore.adminStore.handleUserRightSidebar(true);
      rootStore.adminStore.setUsersActionMenu();
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error.response) {
          if (error.response.status == 400) {
            // the user version is older
            rootStore.errorHandlingStore.displayError(
              "The user version is not compatible, please select different User!"
            );
          } else {
            rootStore.errorHandlingStore.displayError(error.message);
          }
        } else {
          rootStore.errorHandlingStore.displayError(error.message);
        }
      } else {
        rootStore.errorHandlingStore.displayError(
          "unable to get permission, please reload the page!"
        );
      }
    }
  }, [rootStore.adminStore.getSelectedusers, revokePermissionsFromUser]);

  const assignRoles = useCallback(async () => {
    rootStore.rightSidebarStore.setSelectedItems([]);
    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
      const userinformation = JSON.parse(uInfos);
      Mixpanel.track("web_user_assign_role_click", {
        name: userinformation.username,
      });
    }
    // Get list of permissions
    // Prepare columns
    // display selection sidebar
    try {
      const roles: RoleType[] = await rolesService.listAllRoles();

      const columns = RoleTableColumns;
      rootStore.adminStore.handleUserRole({ data: roles, columns: columns });
      rootStore.adminStore.handleUserRightSidebarState({
        title: "Select Role to Assign",
        tableTitle: "Roles",
        description:
          "Please select all the roles you want to assign to the selected users.",
        onSubmit: assignRolesToUser,
        submitButtonTitle: "Assign Roles",
      });
      rootStore.adminStore.handleUserRightSidebarRoleSelection(true);
      rootStore.adminStore.setUsersActionMenu();
    } catch (error) {
      if (error instanceof AxiosError) {
        rootStore.errorHandlingStore.displayError(error.message);
      } else {
        // rootStore.errorHandlingStore.displayError("unable to get roles, please reload the page!");
        rootStore.notificationToastStore.showNotification(
          "unable to get roles, please reload the page!",
          true,
          3000
        );
      }
    }
  }, [assignRolesToUser]);

  const revokeRoles = useCallback(async () => {
    rootStore.rightSidebarStore.setSelectedItems([]);
    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
      const userinformation = JSON.parse(uInfos);
      Mixpanel.track("web_user_revoke_role_click", {
        name: userinformation.username,
      });
    }
    // Get list of permissions
    // Prepare columns
    // display selection sidebar
    try {
      const roles: RoleType[] = await usersService.getUserRoles(
        rootStore.adminStore.getSelectedusers[0] as string
      );

      const columns = RoleTableColumns;
      rootStore.adminStore.handleUserRole({ data: roles, columns: columns });
      rootStore.adminStore.handleUserRightSidebarState({
        title: "Select Role to Revoke",
        tableTitle: "Roles",
        description:
          "Please select all the roles you want to revoke to the selected users.",
        onSubmit: revokeRolesFromUser,
        submitButtonTitle: "Revoke",
      });
      rootStore.adminStore.handleUserRightSidebarRoleSelection(true);
      rootStore.adminStore.setUsersActionMenu();
    } catch (error) {
      if (error instanceof AxiosError) {
        rootStore.errorHandlingStore.displayError(error.message);
        // rootStore.notificationToastStore.showNotification(error.message,true,3000);
      } else {
        // rootStore.errorHandlingStore.displayError("unable to get roles, please reload the page!");
        rootStore.notificationToastStore.showNotification(
          "unable to get roles, please reload the page!",
          true,
          3000
        );
      }
    }
  }, [rootStore.adminStore.getSelectedusers, revokeRolesFromUser]);

  useEffect(() => {
    if (rootStore.adminStore.getUserOrgId) {
      console.log("orgID", toJS(rootStore.adminStore.getUserOrgId));
      rootStore.loadingStore.setShowLoader(true);
      UsersService.getUserbyOrganizationId(rootStore.adminStore.getUserOrgId)
      
        .then((organization) => {
          console.log("📦 API Response (Users by Org):", toJS(organization));
          rootStore.adminStore.handleUsers(organization);
          rootStore.adminStore.handleOriginalUsers(organization);
          rootStore.loadingStore.setShowLoader(false);
        })
        .catch((e: AxiosError) => {
          // console.log("❌ API call failed:", e); // log the full error
          // console.log("❌ Error message:", e.message); // log the message
          // console.log("❌ Error response:", e.response); // log response details (if available)
        
          rootStore.loadingStore.setShowLoader(false);
          rootStore.adminStore.handleUsers([]);
          rootStore.adminStore.handleOriginalUsers([]);
        
          if (e.message.includes("403")) {
            rootStore.errorHandlingStore.displayError("ERROR: User not authorized");
          }
        });
    } else {
      rootStore.loadingStore.setShowLoader(true);

      UsersService.listUsers()
        .then((_users) => {
          rootStore.adminStore.handleUsers(_users);
          rootStore.adminStore.handleOriginalUsers(_users);
          rootStore.loadingStore.setShowLoader(false);
        })
        .catch((e: AxiosError) => {
          rootStore.loadingStore.setShowLoader(false);
          rootStore.adminStore.handleUsers([]);
          rootStore.adminStore.handleOriginalUsers([]);
          if (e.message.includes("403")) {
            rootStore.errorHandlingStore.displayError(
              "ERROR: User not authorized"
            );
          }
        });
    }
  }, [rootStore.adminStore.getUserOrgId, rootStore.adminStore.getupdate]);


  const handlePdfDownload = async () => {
    try {
      let response;
  
      if (selectedOrgId) {
        response = await UsersService.exportOrgPdf(selectedOrgId);
      } else {
        response = await UsersService.exportUsersPdf();
      }
      console.log("filefetched");
      console.log(response.data);
      if (!response.data || response.data.size === 0) {
        throw new Error('Received empty PDF data');
      }
  
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'users.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Failed to export users as PDF', error);
    }
  };

  let userInfo;
  useEffect(() => {
    (async () => {
      userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let roleLabel = JSON.parse(userInfo).roleLabel;
        // rootStore.adminStore.handleRoleLabel(roleLabel);
      }
    })();
  }, [userInfo]);

  const columns = useMemo(() => {
    return UserTableColumns;
  }, []);

  const allOptions = rootStore.adminStore.getUserOrganization.map((org) => (
    <option
      className="action-list"
      style={{
        color: "#333",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "12px",
        fontFamily: "Inter",
        fontSize: "12px",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "16px",
        padding: "12px 20px",
        height: "300px",
        borderRadius: "8px",
        right: "0",
        top: "calc(100% + 20px)",
        zIndex: "100",
        overflow: "auto",
      }}
      value={org.id}
      key={org.id} // Ensure each option has a unique key
    >
      {org.name}
    </option>
  ));
  useEffect(() => {
    // Set up a MobX reaction to trigger when userOrganizationId changes
    const disposer = reaction(
      () => rootStore.adminStore.getUserOrgId, // Observe the organization ID
      (orgId) => {
        // When the organization ID changes, trigger handleFilter
        handleFilter("All Users");
      }
    );

    // Clean up the reaction when the component unmounts
    return () => disposer();
  }, []);

  const [dropdownText1, setDropdownText1] = useState('Select All');

  const allParagraph = (
    <>
      <p
        onClick={() => {
          const orgId = "";
          rootStore.adminStore.handleUserOrgId(orgId)
          setCurrentPage(1);
          setDropdownText("All Users");
          setDropdownText1("Select All")
          setDropdownOpen2(false);
          setSelectedOrgId(null);
        }}
        className="pointer"
        key="select-all"
      >
        Select All
      </p>

      {rootStore.adminStore.getUserOrganization.map(org => (
        <p
          onClick={(e: any) => {
            const orgId = e.target.getAttribute('data-org-id');
            rootStore.adminStore.handleUserOrgId(orgId);
            setDropdownText("All Users");
            setCurrentPage(1);
            setDropdownText1(org.name);
            setDropdownOpen2(false);
            setSelectedOrgId(orgId);
        }}
        data-org-id={org.id}
        className="pointer"
        key={org.id}
      >
        {org.name}
      </p>
      ))}
    </>
  );

  // Filter function to match the search query
  const filteredParagraphs = React.Children.toArray(allParagraph.props.children).filter((child: any) =>
    child.props.children.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // const handleSelect = (org) => {
  //   // Ensure orgId is passed as a string
  //   const orgId = org.id;
  //   rootStore.adminStore.handleUserOrgId(String(orgId));  // Convert to string
  //   setDropdownText1(org.name);  // Update dropdown text with selected org name
  //   setDropdownOpen2(false);  // Close the dropdown
  //   setSearchQuery('');  // Clear the search query
  // };


  // if (performance.navigation.type === 1) {
  //   sessionStorage.clear();
  // }


  // const [dropdownText1, setDropdownText1] = useState(
  //   sessionStorage.getItem('dropdownText1') || 'Select All'
  // );

  // useEffect(() => {
  //   sessionStorage.setItem('dropdownText1', dropdownText1);
  // }, [dropdownText1]);


  // const [dropdownText1, setDropdownText1] = useState('Select All');

  // const allParagraph = rootStore.adminStore.getUserOrganization.map(org=>{
  //   return <p onClick={(e:any) => {
  //     const orgId = e.target.getAttribute('data-org-id');
  //     rootStore.adminStore.handleUserOrgId(orgId);
  //     setCurrentPage(1);
  //     setDropdownText1(org.name);
  //     setDropdownOpen2(false)
  //     }}
  //     data-org-id={org.id}
  //     className='pointer'
  //     key={org.id}
  //     >{org.name}</p>
  // })

  

  const onSearchStrChange = (value: string) => {
    setSearchString(value);
    if (value.trim() === "") {
      rootStore.adminStore.handleUsers(rootStore.adminStore.getOriginalUsers);
    }
  };

  // const onSearch = (value : string) => {
  //   // alert(value)
  //   // alert(JSON.stringify(originalUsersList))

  //   const filteredUsers = originalUsersList.filter((item) => {
  //     return(item.username.toLowerCase().includes(value.toLowerCase())
  //     // ||
  //     //  item..toLowerCase().includes(value.toLowerCase())
  //     // ||
  //     // item.isStandard.toLowerCase().includes(value.toLowerCase())
  //     // ||
  //     // item.fleetType.toLowerCase().includes(value.toLowerCase())
  //     // ||
  //     // item.createdAt.toLowerCase().includes(value.toLowerCase())
  //     // ||
  //     // item.createdAt.toLowerCase().includes(value.toLowerCase())
  //     // ||
  //     // item.organization.name.toLowerCase().includes(value.toLowerCase())
  //     // ||
  //     // item.wifiProvider.toLowerCase().includes(value.toLowerCase())
  //     );

  //    });
  //    rootStore.adminStore.handleUsers(filteredUsers);
  //    setCurrentPage(1);
  //  };
  const onSearch = (value: string) => {
    // alert('fgf');
    const filteredUsers = rootStore.adminStore.getOriginalUsers.filter((user) => {
      return (
        (user.username &&
          user.username.toLowerCase().includes(value.toLowerCase())) ||
        (user.email &&
          user.email.toLowerCase().includes(value.toLowerCase())) ||
        (user.name && user.name.toLowerCase().includes(value.toLowerCase())) ||
        (user.family_name &&
          user.family_name.toLowerCase().includes(value.toLowerCase())) ||
        (user["custom:type"] &&
          user["custom:type"].toLowerCase().includes(value.toLowerCase())) ||
        (user.gender &&
          user.gender.toLowerCase().includes(value.toLowerCase())) ||
        (user.organization &&
          user.organization.toLowerCase().includes(value.toLowerCase()))
      );
    });

    // alert(JSON.stringify(filteredUsers))

    rootStore.adminStore.handleUsers(filteredUsers);
    setCurrentPage(1);
  };

  const [user, setUser] = useState({
    "custom:type": "Select",
    gender: "Select",
  } as UserType);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearch(searchString); // Trigger search when Enter key is pressed
    }
  };
  useEffect(() => {
    (async () => {
      let organizations = await createuserService.getOrganizations();

      rootStore.adminStore.handleCreateFlightOrgList(organizations);
    })();
  }, []);

  const GENDER_OPTIONS = [
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
    {
      label: "Others",
      value: "others",
    },
  ];

  const roleName = rootStore.adminStore.getRoleName;
  const userEmail = rootStore.adminStore.getUserEmail.split("@");
  let last = userEmail[userEmail.length - 1];
  const CUSTOM_TYPE_OPTIONS = [
    {
      label: "Admin",
      value: "admin",
    },
    {
      label: "Crew",
      value: "crew",
    },
    ...(roleName.toLowerCase() != "admin"
      ? [
        // {
        //   label: "Captain",
        //   value: "captain",
        // },
        // {
        //   label: "Coordinator",
        //   value: "coordinator",
        // },
        // {
        //   label: "Dispatch",
        //   value: "dispatch",
        // },

        {
          label: "SuperAdmin",
          value: "superAdmin",
        },

        {
          label: "EMS",
          value: "ems",
        },
      ]
      : []),
    ...(roleName.toLowerCase() == "admin" && `@${last}` == "@vituity.com"
      ? [
        {
          label: "EMS",
          value: "ems",
        },
      ]
      : []),
  ];

  interface MenuItem {
    label: string;
    onClick: () => void;
    disabled?: boolean;
  }
  const menuItems: MenuItem[] = [
    ...(rootStore.adminStore.getRoleName.toLowerCase() !== "admin"
      ? [
        {
          label: "Assign Permissions",
          onClick: assignPermission,
        },
      ]
      : []),
    ...(rootStore.adminStore.getSelectedusers.length === 1 &&
      rootStore.adminStore.getRoleName.toLowerCase() !== "admin"
      ? [
        {
          label: "Revoke Permissions",
          onClick: revokePermissions,
        },
      ]
      : []),
    {
      label: "Assign Roles",
      onClick: assignRoles,
    },
    ...(rootStore.adminStore.getSelectedusers.length === 1
      ? [
        {
          label: "Revoke Roles",
          onClick: revokeRoles,
        },
      ]
      : []),
    {
      label:
        rootStore.adminStore.getSelectedusers.length > 1
          ? "Disable Users"
          : "Disable User",
      onClick: () => {
        let uInfos = localStorage.getItem("userinfo");
        if (uInfos) {
          const userinformation = JSON.parse(uInfos);
          Mixpanel.track("web_disable_user_click", { name: userinformation?.username });
        }
        rootStore.adminStore.handleUserShowDisableConfirmation(true);
        rootStore.adminStore.setUsersActionMenu();
      },
    },
  ];

  const menuListItem = menuItems.map((item) => {
    return <li onClick={item.onClick}>{item.label}</li>;
  });

  useEffect(() => {
    (async () => {
      userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let roleLabel = JSON.parse(userInfo).roleLabel;
        let email = JSON.parse(userInfo).email;
        rootStore.adminStore.handleRoleLabel(roleLabel);
        rootStore.adminStore.handleUserEmail(email);
        if (roleLabel.toLowerCase() == "admin") {
          let username = JSON.parse(userInfo).username;
          let userOrg = await createuserService.getOrgByUserName(username);
          // rootStore.adminStore.handleAddOrg(userOrg.id)
          rootStore.adminStore.handleSelectedOrgId(userOrg.id);
        }
      }
    })();
  }, [userInfo]);

  const onFormSubmit = async ({ value }: { value: any }) => {
    let uInfos = localStorage.getItem("userinfo");
    if (uInfos) {
      const userinformation = JSON.parse(uInfos);
      Mixpanel.track("web_add_user_submit_click", { name: userinformation?.username });
    }
    const { username, email, profile, gender, family_name, name, phoneNumber } =
      value;

    // 🚨 Validate email
    const emailRegex =
      /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(email)) {
      rootStore.errorHandlingStore.displayError("Please enter a valid email address.");
      return;
    }
    // 🚨 Check for gender & profile
    if (!gender || gender === "Select") {
      rootStore.errorHandlingStore.displayError("Please select a gender.");
      return;
    }

    if (!profile || profile === "Select") {
      rootStore.errorHandlingStore.displayError("Please select a profile.");
      return;
    }
    
    if (
      user?.["custom:type"] == "coordinator" &&
      !/^\+1\d{10}$/.test(phoneNumber)
    ) {
      alert(
        "Invalid phone number format. Please enter a phone number in the format +1xxxxxxxxxx"
      );
      return;
    }
    if (rootStore.adminStore.getSelectedOrgId === "") {
      rootStore.errorHandlingStore.displayError(
        "Invalid organization, Please select organization from the dropdown."
      );
    }
    try {
      await createuserService.createUser({
        username,
        email,
        gender,
        familyName: family_name,
        name,
        customType: profile,
        organizationId: Number.parseInt(rootStore.adminStore.getSelectedOrgId),
        phoneNumber,
      });
      rootStore.notificationToastStore.showNotification("Added user!", false, 3000);
      rootStore.adminStore.handleupdate();
      onSearchStrChange("");
      rootStore.adminStore.handleAddUserModal(false);
    } catch (error) {
      console.log(error);
      if (error instanceof AxiosError) {
        rootStore.errorHandlingStore.displayError(error.message);
      } else {
        rootStore.errorHandlingStore.displayError(
          "Error occured while adding user. Please reload the page!"
        );
      }
    } finally {
      rootStore.loadingStore.setShowLoader(false);
    }
  };
  const showAddUser = () => {
    rootStore.adminStore.handleAddUserModal(true);
  };
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const visibleUsersList = rootStore.adminStore.getUsers.slice(
    startIndex,
    endIndex
  );

  const [dropdownText, setDropdownText] = useState('All Users')

  const [filteredVisibleUsersList, setFilteredVisibleUsersList] = useState(visibleUsersList);
  const [filteredData, setFilteredData] = useState(false);

  useEffect(() => {
    setFilteredVisibleUsersList(rootStore.adminStore.getUsers);
  }, []);
  const handleFilter = (t: string) => {
    if (t === 'Enabled Users') {
      setFilteredVisibleUsersList(rootStore.adminStore.getUsers.filter((item) => item.enabled));
      setFilteredData(true);
    } else if (t === 'Disabled Users') {
      setFilteredVisibleUsersList(rootStore.adminStore.getUsers.filter((item) => !item.enabled));
      setFilteredData(true);
    } else if (t === 'All Users') {
      setFilteredVisibleUsersList(visibleUsersList);
      setFilteredData(false);
    }
    setCurrentPage(1);
  };

  const paginatedList = useMemo(() => {
    return filteredVisibleUsersList.slice(startIndex, endIndex);
  }, [filteredVisibleUsersList, startIndex, endIndex]);

  const [isOpen, setIsOpen] = useState(false); // State to track dropdown open/close

  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };

  // Handle outside click

  const dropdownRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLUListElement>(null);
  const dropdownRef2 = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target as Node) &&
        rootStore.adminStore.getUsersActionMenu
      ) {
        rootStore.adminStore.setUsersActionMenu(); // Close the menu
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []); // Setup once

  useEffect(() => {
    const handleClickOutside2 = (e: MouseEvent) => {
      if (dropdownRef2.current && !dropdownRef2.current.contains(e.target as Node)) {
        setDropdownOpen2(false); // Close the dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => document.removeEventListener("mousedown", handleClickOutside2);
  }, []); // Setup once

  // End Handle outside click

  return (
    <Box className="user-screen-container">
      <div className="user-screen-header">
        <div className="user-screen-left-header">
          <CommonSearchInput
            onkeydown={(e: any) => handleKeyDown(e)}
            onchange={(e: any) => onSearchStrChange(e.target.value)}
          />
          <CommonButton
            title="Search"
            padding="12px 24px 12px 28px"
            color="#fff"
            bgColor="#357EFF"
            radius={10}
            border="1px solid #357EFF"
            lineheight="14px"
            ml={5}
            onclick={(e: any) => onSearch(searchString)}
          />
        </div>
        <div className="user-screen-left-header">
          <button
            onClick={handlePdfDownload}
            style={{
              padding: '12px 24px 12px 28px',
              color: '#fff',
              backgroundColor: '#357EFF',
              border: '1px solid #357EFF',
              borderRadius: '10px',
              lineHeight: '14px',
              marginLeft: '5px',
              cursor: 'pointer',
              fontSize: "14px",
              fontWeight: "600"
            }}
          >
            Export PDF
          </button>
        </div>
        <div className="user-screen-right-header">
          <div style={{ maxHeight: '40px' }}>
            <Button
              style={{
                display: "flex",
                width: "148px",
                padding: "8px 8px 8px 12px",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: "8px",
                border: '1px solid rgb(237 237 235)',
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "520",
                lineHeight: "20px",
              }}
              className="users-action-btn"
              onClick={handleButtonClick}
            >
              {dropdownText}
              <img
                style={{
                  width: "24px",
                  height: "24px",
                  flexShrink: "0",
                  transform: dropdownOpen1 ? 'rotate(180deg)' : 'rotate(0deg)'
                }}
                src={userActionDropdown}
                alt="Dropdown Icon"
              />
            </Button>
            {dropdownOpen1 && (
              <div
                className="dropdown-menu"
                ref={dropdownRef}
                style={{
                  position: 'relative',
                  top: '23.5%',
                  width: '148px',
                  backgroundColor: '#fff',
                  border: '1px solid #ddd',
                  zIndex: '1',
                  borderTopRightRadius: '10px',
                  borderTopLeftRadius: '10px'
                }}
              >
                <div
                  style={{
                    fontSize: '14px',
                    width: '100%'
                  }}
                >
                  <p onClick={() => {
                    setDropdownText('All Users');
                    setDropdownOpen1(false)
                    handleFilter('All Users')
                  }}
                    className='pointer'
                  >All Users</p>

                  <p onClick={() => {
                    setDropdownText('Enabled Users');
                    setDropdownOpen1(false)
                    handleFilter("Enabled Users")
                  }}
                    className='pointer'
                  >Enabled Users</p>
                  <p onClick={() => {
                    setDropdownText('Disabled Users');
                    setDropdownOpen1(false)
                    handleFilter("Disabled Users")
                  }}
                    className='pointer'
                  >Disabled Users</p>
                </div>
              </div>
            )}
          </div>
          <Box
            className="user-action-list-outer"
            style={{ position: "relative" }}
          >
            <Button
              style={{
                display: "flex",
                width: "148px",
                padding: "8px 8px 8px 12px",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: "8px",
                background: "#E9F2FF",
                color: "#4B628A",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: "500",
                lineHeight: "20px",
              }}
              className="users-action-btn"
              disabled={
                rootStore.adminStore.getSelectedusers.length > 0 ? false : true
              }
              onClick={() => rootStore.adminStore.setUsersActionMenu()}
            >
              Action
              <img
                className={
                  rootStore.adminStore.getUsersActionMenu
                    ? "rotate180"
                    : "rotate0"
                }
                style={{
                  width: "24px",
                  height: "24px",
                  flexShrink: "0",
                }}
                src={userActionDropdown}
                alt="Dropdown Icon"
              />
            </Button>
            {rootStore.adminStore.getUsersActionMenu && (
              <ul className="action-list" id="actionList" ref={menuRef}>{menuListItem}</ul>
            )}
          </Box>
          {rootStore.adminStore.getRoleName.toLowerCase() !== "admin" && (
            // <select


            //   className="org-list"
            //   // style={{ position: 'relative', display: 'inline-block' }}
            //   style={{
            //     appearance: "none",
            //     WebkitAppearance: "none",
            //     MozAppearance: "none",
            //     padding: "10px 8px",
            //     color: "#4B628A",
            //     backgroundColor: "#E9F2FF",
            //     width: "148px",
            //     borderRadius: "8px",
            //     lineHeight: "20px",
            //     marginLeft: "5px",
            //     fontFamily: "Inter",
            //     fontSize: "14px",
            //     fontStyle: "normal",
            //     fontWeight: "500",
            //     border: "unset",
            //     backgroundImage: `url(${userActionDropdown})`, // Use your arrow image here
            //     backgroundRepeat: "no-repeat",
            //     backgroundPosition: "right 8px center", // Adjust position as needed
            //     paddingRight: "2rem", // Adjust padding to accommodate image width and gap
            //     outline: "none", // Remove default outline on focus
            //     height: "300px",
            //     overflowY: "scroll"
            //   }}
            //   onClick={toggleDropdown} // Toggle dropdown on click
            //   onBlur={() => setIsOpen(false)}
            //   onChange={(e) => {
            //     rootStore.adminStore.handleUserOrgId(e.target.value);
            //     setCurrentPage(1);
            //   }}
            //   value={rootStore.adminStore.getUserOrgId}
            // >
            //   {/* <option disabled={true} style={{color:"#fff"}}>Please Select Organization</option> */}
            //   {allOptions}
            //   <option
            //     style={{
            //       color: "#333",
            //       display: "flex",
            //       flexDirection: "column",
            //       alignItems: "flex-start",
            //       gap: "12px",
            //       fontFamily: "Inter",
            //       fontSize: "12px",
            //       fontStyle: "normal",
            //       fontWeight: "500",
            //       lineHeight: "16px",

            //       padding: "12px 20px",
            //       height: "300px",
            //       top: "calc(100% + 5px)",
            //     }}
            //     value=""
            //   >
            //     Select All{" "}
            //   </option>
            //   <img
            //     className={
            //       rootStore.adminStore.getUsersActionMenu
            //         ? "rotate180"
            //         : "rotate0"
            //     }
            //     style={{
            //       position: "absolute",
            //       right: "8px", // Adjust position as needed
            //       top: "50%", // Center vertically
            //       transform: "translateY(-50%)",
            //       width: "24px",
            //       height: "24px",
            //       pointerEvents: "none", // Ensure clicks pass through to the select element
            //     }}
            //     src={userActionDropdown}
            //     alt="Dropdown Icon"
            //   />
            // </select>

            <div style={{ maxHeight: '40px' }}>
              <Button
                style={{
                  display: 'flex',
                  width: '148px',
                  padding: '8px 8px 8px 12px',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  borderRadius: '8px',
                  border: '1px solid rgb(237 237 235)',
                  color: '#4B628A',
                  fontFamily: 'Inter',
                  fontSize: '13px',
                  fontStyle: 'normal',
                  fontWeight: '520',
                  lineHeight: '20px',
                  backgroundColor: '#eafbfa',
                }}
                className="users-action-btn"
                onClick={handleButtonClick2}
              >
                {dropdownText1}
                <img
                  style={{
                    width: '24px',
                    height: '24px',
                    flexShrink: '0',
                    transform: dropdownOpen2 ? 'rotate(180deg)' : 'rotate(0deg)',
                  }}
                  src={userActionDropdown} // Ensure `userActionDropdown` is defined elsewhere
                  alt="Dropdown Icon"
                />
              </Button>

              {dropdownOpen2 && (
                <div
                  className="dropdown-menu"
                  ref={dropdownRef2}
                  style={{
                    position: 'relative',
                    top: '23.5%',
                    width: '148px',
                    backgroundColor: '#fff',
                    border: '1px solid #ddd',
                    zIndex: '1',
                    borderRadius: '10px',
                  }}
                >
                  {/* Input field for search */}
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="
                    Search..."
                    style={{
                      width: '100%',
                      padding: '8px',
                      borderRadius: '8px 8px 0 0',
                      border: '1px solid #ccc',
                      marginBottom: '5px',
                    }}
                  />

                  {/* The filtered paragraphs rendered here */}
                  <div
                    style={{
                      fontSize: '14px',
                      width: '100%',
                      maxHeight: '325px',
                      overflowY: 'scroll',
                      scrollbarWidth: 'none',
                      msOverflowStyle: 'none',
                    }}
                  >
                    {filteredParagraphs}
                  </div>
                </div>
              )}
            </div>


            //       <div style={{maxHeight:'40px'}}>
            //    <Button
            //         style={{
            //           display: "flex",
            //           width: "148px",
            //           padding: "8px 8px 8px 12px",
            //           justifyContent: "space-between",
            //           alignItems: "center",
            //           borderRadius: "8px",
            //           border:'1px solid rgb(237 237 235)',
            //           color: "#4B628A",
            //           fontFamily: "Inter",
            //           fontSize: "13px",
            //           fontStyle: "normal",
            //           fontWeight: "520",
            //           lineHeight: "20px",
            //           backgroundColor:'#eafbfa'
            //         }}
            //         className="users-action-btn"
            //         onClick={handleButtonClick2}
            //       >
            //         {dropdownText1}
            //         <img
            //           style={{
            //             width: "24px",
            //             height: "24px",
            //             flexShrink: "0",
            //             transform: dropdownOpen2?'rotate(180deg)':'rotate(0deg)'
            //           }}
            //           src={userActionDropdown}
            //           alt="Dropdown Icon"
            //         />
            //       </Button>
            //       {dropdownOpen2 && (
            //   <div
            //     className="dropdown-menu"
            //     style={{
            //       position: 'relative',
            //       top: '23.5%',
            //       width: '148px',
            //       backgroundColor: '#fff',
            //       border: '1px solid #ddd',
            //       zIndex: '1',
            //       borderRadius:'10px'
            //     }}
            //   >
            //     <div
            //     style={{
            //       fontSize:'14px',
            //       width:'100%',
            //       maxHeight:'325px',
            //       overflowY:'scroll',
            //       scrollbarWidth: 'none', 
            //       msOverflowStyle: 'none',
            //     }}
            //     >
            //       {allParagraph}
            //     </div>
            //   </div>
            // )}
            //    </div>
          )}
          <CommonButton
            title="Add User"
            padding="12px 14px"
            color="#fff"
            bgColor="#357EFF"
            radius={10}
            border="1px solid #357EFF"
            lineheight="14px"
            ml={5}
            onclick={showAddUser}
          />
        </div>
        {/* <Button
          primary
          color={"brand-1"}
          label="Reset Password"
          onClick={() => {

            let uInfos = localStorage.getItem("userinfo");
            if(uInfos)
              {
            const userinformation = JSON.parse(uInfos);
            
            Mixpanel.track("web_user_reset_password_button_click",{name:userinformation.username});
              }
            navigate("/reset-password");
          }}
        /> */}
        {/* <Button
          primary
          color={"brand-1"}
          label="Add User"
          onClick={() => {
            let uInfos = localStorage.getItem("userinfo");
            if(uInfos)
              {
            const userinformation = JSON.parse(uInfos);
            Mixpanel.track("web_add_user_button_click",{name:userinformation.username});
              }

            navigate("/create-user");
          }}
        /> */}
        {/* {
          rootStore.adminStore.getRoleName.toLowerCase() !== "admin"
          &&
          <Button
            primary
            color={"brand-1"}
            label="Add Organization"
            onClick={() => {
              
 let uInfos = localStorage.getItem("userinfo");
 if(uInfos)
   {
 const userinformation = JSON.parse(uInfos);
              Mixpanel.track("web_add_organization_button_click",{name:userinformation.username});
   }
              navigate("/create-organization");
            }}
          />
        } */}
        {/* <Button
          primary
          color={"brand-1"}
          label="Add Flight"
          onClick={() => {
            
 let uInfos = localStorage.getItem("userinfo");
 if(uInfos)
   {
 const userinformation = JSON.parse(uInfos);
            Mixpanel.track("web_add_flight_button_click",{name:userinformation.username});
   }
            navigate("/create-flight");
          }}
        /> */}

        {/* <Menu
              label="Actions"
              items={[
                [
                  {
                    label: "Assign Permissions",
                    onClick: assignPermission,
                  },
                  ...(rootStore.adminStore.getSelectedusers.length === 1
                    ? [
                        {
                          label: "Revoke Permissions",
                          onClick: revokePermissions,
                        },
                      ]
                    : []),
                  {
                    label: "Assign Roles",
                    onClick: assignRoles,
                  },
                  ...(rootStore.adminStore.getSelectedusers.length === 1
                    ? [
                        {
                          label: "Revoke Roles",
                          onClick: revokeRoles,
                        },
                      ]
                    : []),
                ],
                [
                  {
                    label:
                    rootStore.adminStore.getSelectedusers.length > 1
                        ? "Disable Users"
                        : "Disable User",
                    onClick: () => {
                      let uInfos = localStorage.getItem("userinfo");
                      if(uInfos)
                        {
                      const userinformation = JSON.parse(uInfos);
                      Mixpanel.track("web_disable_user_click",{name:userinformation.username});
                        }
                      rootStore.adminStore.handleUserShowDisableConfirmation(true);
                    },
                  },
                ],
              ]}
            /> */}
      </div>
      <div className="table-overflow" style={{ height: visibleUsersList.length ? "100%" : "auto" }}>
        <DataTable
          className="user-list-table-container"
          columns={columns}
          // data={filteredVisibleUsersList.length?filteredVisibleUsersList:visibleUsersList}
          data = {paginatedList.length?paginatedList:visibleUsersList}
          resizeable
          step={itemsPerPage}
          // paginate
          // {...longPressEvent}

          {...(true
            ? {
              onClickRow: (event) => { },
            }
            : {})}
          {...(true
            ? {
              select: rootStore.adminStore.getSelectedusers,
              onSelect: (items) => {
                // if (items.length == 0) rootStore.adminStore.handleUserSelectedActivation(true);
                rootStore.adminStore.handleSelectedUser(items);
                if (rootStore.adminStore.resetUserActionMenu) {
                  rootStore.adminStore.resetUserActionMenu();
                }
              },
            }
            : {})}
        />
      </div>
      {Math.ceil(rootStore.adminStore.getUsers.length / itemsPerPage) > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={!filteredData ? Math.ceil(
            rootStore.adminStore.getUsers.length / itemsPerPage
          ) : Math.ceil(filteredVisibleUsersList.length / itemsPerPage)}
          totalItems={!filteredData ? rootStore.adminStore.getUsers.length : filteredVisibleUsersList.length}
          onPageChange={handlePageChange}
        />
      )}
      {rootStore.adminStore.getUsers.length === 0 ? (
        <div className="spinner-container">
          <img src={NoDataFound} />
          <p>No Data Found</p>
        </div>
      ) : (
        <></>
      )}
      {rootStore.adminStore.getUserRightSidebarShow ? (
        <RightSidebar
          {...rootStore.adminStore.getUserRightSidebarState}
          onCancel={() => {
            rootStore.adminStore.handleUserRightSidebar(false);
          }}
          tableData={rootStore.adminStore.getUserPermissionTableState.data}
          columns={rootStore.adminStore.getUserPermissionTableState.columns}
          showSubmitButton={true}
        />
      ) : (
        <></>
      )}
      {rootStore.adminStore.getUserRightSidebarRoleSelection ? (
        <RightSidebar
          {...rootStore.adminStore.getUserRightSidebarState}
          onCancel={() =>
            rootStore.adminStore.handleUserRightSidebarRoleSelection(false)
          }
          tableData={rootStore.adminStore.getUserRole.data}
          columns={rootStore.adminStore.getUserRole.columns}
          showSubmitButton={true}
        />
      ) : (
        <></>
      )}
      {rootStore.adminStore.getUserShowDisableConfirmation ? (
        <DisableRightSidebar
        // {...rootStore.adminStore.getUserRightSidebarState}
        // onCancel={() => rootStore.adminStore.handleUserRightSidebarRoleSelection(false)}
        // tableData={rootStore.adminStore.getUserRole.data}
        // columns={rootStore.adminStore.getUserRole.columns}
        // showSubmitButton={true}
        />
      ) : (
        <></>
      )}
      {rootStore.adminStore.getEditProfileUser ? (
        <EditProfileUsers
        // {...rootStore.adminStore.getUserRightSidebarState}
        // onCancel={() => rootStore.adminStore.handleUserRightSidebarRoleSelection(false)}
        // tableData={rootStore.adminStore.getUserRole.data}
        // columns={rootStore.adminStore.getUserRole.columns}
        // showSubmitButton={true}
        />
      ) : (
        <></>
      )}

      {/* <ConfirmationDialog
        show={rootStore.adminStore.getUserShowDisableConfirmation}
        onCancel={() => {
          ("web_disable_user_cancel_click");
          rootStore.adminStore.handleUserShowDisableConfirmation(false);
        }}
        onDone={async () => {
          ("web_disable_user_submit_click");
          try {
            await usersService.disableUsers(rootStore.adminStore.getSelectedusers as string[]);
          } catch (e) {
            if (e instanceof AxiosError) {
              rootStore.errorHandlingStore.displayError(e.message);
            } else {
              rootStore.errorHandlingStore.displayError("Error occured while disabling users.");
            }
          }
          rootStore.adminStore.handleUserShowDisableConfirmation(false);
          rootStore.notificationToastStore.showNotification("Users disabled!",false, 3000);
          rootStore.adminStore.handleUserOrgId("");
          usersService.listUsers().then((users) => rootStore.adminStore.handleUsers(users));
        }}
        confimButtonText="Disable"
        title="Are you sure to disable the users?"
        typingValidationText="DISABLE"
      /> */}
      {rootStore.adminStore.getAddUserModal && (
        <Layer
          className="outer"
          full="vertical"
          position="right"
          onClickOutside={() => {
            rootStore.adminStore.handleAddUserModal(false);
          }}
          onEsc={() => {
            rootStore.adminStore.handleAddUserModal(false);
          }}
          style={{ borderRadius: "12px 0 0 12px", zIndex: 1000 }}
        >
          <Box className="create-user-container" style={{ maxWidth: "500px" }}>
            <Box className="add-user-modal">
              <h4>Add Users</h4>
              <Button
               className="close-btn"
                onClick={() => {
                  onSearchStrChange("");
                  rootStore.adminStore.handleAddUserModal(false);
                }}
              >
                <img
                  src={closeAddUserSidebar}
                  style={{ width: 20, height: 20 }}
                />
                Close
              </Button>
            </Box>
            <Box className="over-add-user">
              <Box className="add-user-modal-container">
                <Box className="add-user-modal-browserbox">
                  <Box className="add-user-modal-filebrowse">
                    <p>
                      <img src={excelFileAddUser} />
                      Upload an excel file containing list of users
                    </p>
                    <label
                      style={{
                        cursor: "pointer",
                        color: "#357EFF",
                        textAlign: "center",
                        fontFamily: "Inter",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: "600",
                        lineHeight: "18px",
                      }}
                      htmlFor="fileInput"
                    >
                      Browse
                    </label>
                    {/* <input
                      id="fileInput"
                      type="file"
                      accept=".xls,.xlsx"
                      style={{ display: "none" }}
                      onChange={(event) => {
                        let fileList = null;
                        if (event != undefined) fileList = event.target.files;

                        if (fileList != null) {
                          for (let i = 0; i < fileList.length; i += 1) {
                            const file = fileList[i];
                            createuserService
                              .readFile(file)
                              .then((data: UserFromFileType[]) => {
                                rootStore.adminStore.handleShowBatchButton(
                                  true
                                );
                                rootStore.adminStore.handleFormFile(data);
                              });
                          }
                        }
                      }}
                    /> */}

                    <input
                      id="fileInput"
                      type="file"
                      accept=".xls,.xlsx"
                      style={{ display: "none" }}
                      onChange={(event) => {
                        setFileError(""); // Reset error on new file selection
                        const fileList = event.target.files;
                        if (!fileList || fileList.length === 0) return;

                        const file = fileList[0];
                        const allowedExtensions = [".xls", ".xlsx"];
                        const fileExtension = file.name.split('.').pop()?.toLowerCase();

                        // Validate file type
                        if (!fileExtension || !allowedExtensions.includes(`.${fileExtension}`)) {
                          setFileError("Error: Only Excel files (.xls, .xlsx) are supported.");
                          return;
                        }

                        // Validate file size (max 10MB)
                        const maxSize = 10 * 1024 * 1024;
                        if (file.size > maxSize) {
                          setFileError("Error: File size exceeds 10MB. Please upload a smaller file.");
                          return;
                        }

                        // Process file if validations pass
                        createuserService
                          .readFile(file)
                          .then((data: UserFromFileType[]) => {
                            rootStore.adminStore.handleShowBatchButton(true);
                            rootStore.adminStore.handleFormFile(data);
                          })
                          .catch(() => {
                            setFileError("Failed to process the file. Please try again.");
                          });
                      }}
                    />
                  </Box>
                  {fileError && (
                    <p style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                      {fileError}
                    </p>
                  )}
                </Box>
                <Box className="add-user-modal-paratext">
                  <p className="add-user-modal-text">OR</p>
                </Box>

                <Form
                  validate="change"
                  onSubmit={onFormSubmit}
                  className="add-user-modal-form"
                >
                  <FormField
                    className="add-user-modal-form-F1"
                    name="username"
                    htmlFor="textinput-id"
                    placeholder="username"
                    validate={[
                      {
                        regexp: /^[a-zA-Z0-9]+$/,
                        message: "Username cannot contain special characters.",
                      },
                      {
                        regexp: /^.{3,50}$/,
                        message: "Username must be between 3 and 50 characters.",
                      }
                    ]}
                  >
                    <label>Username</label>
                    <TextInput
                      className="add-user-modal-form-I1"
                      placeholder="Username"
                      id="textinput-id"
                      name="username"
                      required
                      maxLength={50}
                      onChange={(event) => {
                        setUser((prev: any) => {
                          return {
                            ...prev,
                            username: event.target.value,
                          };
                        });
                      }}
                    />
                  </FormField>
                  <FormField
                    className="add-user-modal-form-F2"
                    name="email"
                    htmlFor="textinput-id"
                    validate={[
                      {
                        // regexp:
                        //   /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        regexp: /^[a-zA-Z0-9][a-zA-Z0-9._-]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
                        message: "Invalid email format.",
                      },
                    ]}
                  >
                    <label className="add-user-modal-form-L1">Email</label>
                    <TextInput
                      style={{
                        color: "#41454B",
                        fontFamily: "Inter",

                        fontStyle: "normal",
                        fontWeight: "600",
                      }}
                      required
                      className="add-user-modal-form-I2"
                      id="textinput-id"
                      name="email"
                      type={"email"}
                      placeholder="Email"
                      maxLength={50}
                      onChange={(event) => {
                        const lowercaseEmail = event.target.value.toLowerCase();
                        event.target.value = lowercaseEmail;
                        setUser((prev: any) => {
                          return {
                            ...prev,
                            email: lowercaseEmail,
                          };
                        });
                      }}
                    />
                  </FormField>
                  <div style={{
                    width: '100%',
                    display: 'flex',
                    gap: "10px"
                  }}>
                    <FormField
                      className="add-user-modal-form-F1"
                      name="name"
                      htmlFor="firstname-input"
                      validate={[
                        {
                          regexp: /^[A-Za-z]+$/,
                          message: "First Name should contain only alphabets.",
                        },
                      ]}
                    >
                      <label className="add-user-modal-form-L1">First Name</label>
                      <TextInput
                        style={{
                          color: "#41454B",
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          fontWeight: "600",
                        }}
                        placeholder="First Name"
                        className="add-user-modal-form-I1"
                        name="name"
                        id="firstname-input"
                        required
                        maxLength={40}
                        onChange={(event) => {
                          setUser((prev: any) => {
                            return {
                              ...prev,
                              name: event.target.value,
                            };
                          });
                        }}
                      />
                    </FormField>

                    <FormField
                      className="add-user-modal-form-F1"
                      name="family_name"
                      htmlFor="lastname-input"
                      validate={[
                        {
                          regexp: /^[A-Za-z]+$/,
                          message: "Last Name should contain only alphabets.",
                        },
                      ]}
                    >
                      <label className="add-user-modal-form-L1">Last Name</label>
                      <TextInput
                        style={{
                          color: "#41454B",
                          fontFamily: "Inter",
                          fontStyle: "normal",
                          fontWeight: "600",
                        }}
                        className="add-user-modal-form-I1"
                        id="lastname-input"
                        required
                        maxLength={40}
                        name="family_name"
                        placeholder="Last Name"
                        onChange={(event) => {
                          setUser((prev: any) => {
                            return {
                              ...prev,
                              family_name: event.target.value,
                            };
                          });
                        }}
                      />
                    </FormField>
                  </div>
                  {/* <div
                    className="add-user-modal-form-L7"
                    style={{ width: "100%" }}
                  >
                    <label className="add-user-modal-form-L1">Gender</label>
                    <div style={{ width: "100%" }} className="add-user-sadmin">
                      <Select
                        className="add-user-select select"
                        name="gender"
                        labelKey={"label"}
                        valueKey={{ key: "value", reduce: true }}
                        options={GENDER_OPTIONS}
                        placeholder="Select"
                        defaultValue={""}
                        value={user.gender}
                        onChange={(event) => {
                          setUser((prev: any) => {
                            return {
                              ...prev,
                              gender: event.option.value,
                            };
                          });
                        }}
                      />
                    </div>
                  </div> */}

                  <div
                    className="add-user-modal-form-L7"
                    style={{ width: "100%" }}
                  >
                    <FormField
                      className="add-user-modal-form-F1"
                      name="gender"
                      label="Gender"
                      required
                      validate={[
                        (value: any) => (!value || value === "Select" ? "Gender is required" : undefined),
                      ]}
                    >
                      <div style={{ width: "100%" }} className="add-user-sadmin">
                        <Select
                          style={{
                            color: "#41454B",
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: "600",
                          }}
                          className="add-user-select select"
                          name="gender"
                          labelKey={"label"}
                          valueKey={{ key: "value", reduce: true }}
                          options={GENDER_OPTIONS}
                          placeholder="Select"
                          defaultValue={""}
                          value={user.gender}
                          onChange={(event) => {
                            setUser((prev: any) => {
                              return {
                                ...prev,
                                gender: event.option.value,
                              };
                            });
                          }}
                        />
                      </div>
                    </FormField>
                  </div>

                  {/* <div
                    className="add-user-modal-form-L7"
                    style={{ width: "100%" }}
                  >
                    <label className="add-user-modal-form-L1">Profile</label>
                    <div style={{ width: "100%" }} className="add-user-sadmin">
                      <Select
                        className="add-user-select select"
                        name="profile"
                        labelKey={"label"}
                        valueKey={{ key: "value", reduce: true }}
                        options={CUSTOM_TYPE_OPTIONS}
                        value={user["custom:type"]}
                        defaultValue={""}
                        placeholder="Select"
                        onChange={(event) => {
                          setUser((prev: any) => {
                            return {
                              ...prev,
                              "custom:type": event.option.value,
                            };
                          });
                        }}
                      />
                    </div>
                  </div> */}

                  <div
                    className="add-user-modal-form-L7"
                    style={{ width: "100%" }}
                  >
                    <FormField
                      className="add-user-modal-form-F1"
                      name="profile"
                      label="Profile"
                      required
                      validate={[
                        (value: any) => (!value || value === "Select" ? "Profile is required" : undefined),
                      ]}
                    >
                      <div style={{ width: "100%" }} className="add-user-sadmin">
                        <Select
                          style={{
                            color: "#41454B",
                            fontFamily: "Inter",
                            fontStyle: "normal",
                            fontWeight: "600",
                          }}
                          className="add-user-select select"
                          name="profile"
                          labelKey={"label"}
                          valueKey={{ key: "value", reduce: true }}
                          options={CUSTOM_TYPE_OPTIONS}
                          value={user["custom:type"]}
                          defaultValue={""}
                          placeholder="Select"
                          onChange={(event) => {
                            setUser((prev: any) => {
                              return {
                                ...prev,
                                "custom:type": event.option.value,
                              };
                            });
                          }}
                        />
                      </div>
                    </FormField>
                  </div>

                  <div
                    className="add-user-modal-form-L7"
                    style={{ width: "100%" }}
                  >
                    <label className="add-user-modal-form-L1">
                      Organization
                    </label>
                    <div
                      style={{ width: "100%" }}
                      className={
                        rootStore.adminStore.getRoleName.toLowerCase() ==
                          "admin"
                          ? "create-user-org-outer"
                          : "add-user-sadmin"
                      }
                    >

                      <Select
                        className="add-user-select select"
                        name="organization"
                        labelKey="label"
                        valueKey={{ key: "value", reduce: true }} // Add "reduce: true" here
                        options={filteredOptions.map((org) => ({
                          label: org.name,
                          value: org.id,
                        }))}
                        value={rootStore.adminStore.getSelectedOrgId}
                        placeholder="Select"
                        onChange={(event) => {
                          if (rootStore.adminStore.getRoleName.toLowerCase() !== "admin") {
                            rootStore.adminStore.handleSelectedOrgId(event.option.value);
                          }
                        }}
                        onSearch={(text) => setSearchText(text)}
                      />
                    </div>
                  </div>

                  {rootStore.adminStore.getOrgList.length > 0 ? (
                    <FormField
                      label="Organization"
                      name="organization"
                      htmlFor="textinput-id"
                      required
                    >
                      <Select
                        name="organization"
                        labelKey={"label"}
                        valueKey={{ key: "value", reduce: true }}
                        options={rootStore.adminStore.getOrgList.map((org) => {
                          return {
                            label: org.name,
                            value: org.id,
                          };
                        })}
                        value={rootStore.adminStore.getSelectedOrgId}
                        defaultValue={""}
                        onChange={(event) => {
                          rootStore.adminStore.handleSelectedOrgId(
                            event.option.value
                          );
                        }}
                      />
                    </FormField>
                  ) : (
                    <></>
                  )}

                  <Box
                    className="add-user-modal-btn"
                    as="footer"
                  >
                    <Button
                      className="add-user-modal-btn-1"
                      type="reset"
                      onClick={() => {
                        let uInfos = localStorage.getItem("userinfo");
                        if (uInfos) {
                          const userinformation = JSON.parse(uInfos);
                          Mixpanel.track("web_add_user_reset_click", { name: userinformation?.username });
                        }
                        setUser((prev: any) => {
                          return {
                            ...prev,
                            "custom:type": "",
                            gender: "",
                          };
                        });
                        if (rootStore.adminStore.getRoleName.toLowerCase() != "admin") {
                          rootStore.adminStore.handleSelectedOrgId("");
                        }
                      }}
                      label="Reset"
                      color={"brand-1"}
                    />
                    <Button
                      className="add-user-modal-btn-2"
                      type="submit"
                      primary
                      label="Add"
                      color={"brand-1"}
                    />
                  </Box>
                </Form>
              </Box>
              {/* {/ <Box className="create-user-container"> /} */}
              <p className="message-text"></p>
              {/* <Card>
    <FileInput
          title="Upload an excel file for adding a batch."
          messages={{
            dropPrompt: "Upload an excel file containing list of users.",
          }}
          onChange={(event) => {
            let fileList = null;
            if (event != undefined) fileList = event.target.files;

            if (fileList != null) {
              for (let i = 0; i < fileList.length; i += 1) {
                const file = fileList[i];
                createuserService
                  .readFile(file)
                  .then((data) => {
                    rootStore.adminStore.handleShowBatchButton(true);
                    rootStore.adminStore.handleFormFile(data);
                  });
              }
            }
          }}
        />
        {rootStore.adminStore.getShowBatchButton ? (
          <Box direction="row" gap="medium" pad={"medium"} justify="end">
            <Button
              type="button"
              primary
              label="Batch Add"
              color={"brand-1"}
              onClick={batchAddUsers}
            />
          </Box>
        ) : (
          <></>
        )}
    </Card> */}
            </Box>
          </Box>
        </Layer>
      )}
    </Box>
  );
});

export default Users;
